import React from 'react';

import {format} from 'date-fns';
import {useStore} from 'effector-react';
import i18next from 'i18next';
import {useTranslation} from 'react-i18next';

import {validateCode} from 'api';
import {BackTo} from 'components/common/BackTo';
import {Stepper} from 'components/ui-kit/Stepper';
import {DocumentReportType} from 'core/dictionaries';
import {ROUTE} from 'core/routes';
import {
    commissioningForm$,
    createCommissioningDocument,
    DocumentsCreateGate,
    step$,
} from 'models/documents/create';

import {CodeRequestType, CodeResponseType} from 'types/validation';

import {ProductCodes} from '../common/products';
import {ContentWrapper} from '../common/styled';

import {DocumentForm} from './form';

export const CreateCommissioning = () => {
    const {t} = useTranslation();
    const step = useStore(step$);
    const commissioningForm = useStore(commissioningForm$);

    const validation = async (markingCode: string, data: CodeResponseType['info'][]) => {
        const errors: string[] = [];

        const DATE_PATTERN = "yyyy-MM-dd'T'HH:mm:ss.sss'Z'";
        try {
            const payload: CodeRequestType = {
                startCirculationDate: format(
                    new Date(commissioningForm.startCirculationDate!),
                    DATE_PATTERN,
                ),
                type: DocumentReportType.INTRODUCE,
                markingCode,
            };
            const codeData = (await validateCode(payload)).data;
            errors.push(...codeData.errors.map((e) => e.message));

            if (data.find((d) => d.identityCode === codeData.info.identityCode))
                errors.push(i18next.t('components.scan.errors.double'));

            return {errors, codeData: codeData.info};
        } catch (e) {
            console.error(e);
            errors.push('Invalid code');
            return {errors, codeData: null};
        }
    };

    return (
        <>
            <BackTo to={ROUTE.DOCUMENTS_DOCUMENTS}>{t('pages.documents.back')}</BackTo>
            <ContentWrapper>
                <h1>{t('pages.documents.newDocumentCommissioning')}</h1>
                <DocumentsCreateGate />
                <Stepper
                    steps={[
                        {
                            label: t('pages.documents.stepOne'),
                            component: <DocumentForm />,
                        },
                        {
                            label: t('pages.documents.stepTwo'),
                            component: (
                                <ProductCodes
                                    createDocument={createCommissioningDocument}
                                    validation={validation}
                                />
                            ),
                        },
                    ]}
                    activeStep={step}
                />
            </ContentWrapper>
        </>
    );
};
